import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BarChart3, Users, Camera, Loader2 } from "lucide-react";
import { http, handle } from "@/api/http";
import { TrackingLayout, RequestError } from "@/components/tracking/TrackingLayout";
import { AdminMetrics, AdminChart, AdminPlatforms, AdminActions, AdminLatest } from "@/components/admin/AdminPanels";

export default function Admin() {
  const { t, i18n } = useTranslation();
  const [stats, setStats] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState("");
  const [reminders, setReminders] = useState(null);

  useEffect(() => {
    let active = true;
    handle(http.get("/admin/stats"))
      .then((data) => { if (active) setStats(data); })
      .catch((failure) => { if (active) setError(failure.message); });
    return () => { active = false; };
  }, []);

  const downloadCsv = async () => {
    setBusy("csv"); setError("");
    try {
      const response = await http.get("/admin/accounts.csv", { responseType: "blob" });
      const url = URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.download = `skinly-contas-${new Date().toISOString().slice(0, 10)}.csv`;
      link.click();
      URL.revokeObjectURL(url);
    } catch (failure) { setError(failure.message); } finally { setBusy(""); }
  };

  const checkReminders = async () => {
    setBusy("reminders"); setError("");
    try {
      setReminders(await handle(http.post("/admin/run-reminders?dry_run=true")));
    } catch (failure) { setError(failure.message); } finally { setBusy(""); }
  };

  return <TrackingLayout title={t("admin.title")} icon={BarChart3} testId="admin">
    <RequestError error={error} testId="admin-error" />
    {!stats && !error && <div className="flex justify-center py-16" data-testid="admin-loading">
      <Loader2 className="w-8 h-8 text-primary animate-spin" />
    </div>}
    {stats && <>
      <AdminMetrics totals={stats.totals} />
      <AdminPlatforms platforms={stats.platforms} />
      <AdminChart title={t("admin.signupsByDay")} data={stats.signups_by_day} icon={Users} testId="admin-signups-chart" />
      <AdminChart title={t("admin.analysesByDay")} data={stats.analyses_by_day} icon={Camera} testId="admin-analyses-chart" />
      <AdminActions busy={busy} onExport={downloadCsv} onCheckReminders={checkReminders} reminders={reminders} />
      <AdminLatest accounts={stats.latest_accounts} locale={i18n.language} />
    </>}
  </TrackingLayout>;
}
